import { apiFetch } from "@/lib/api";

export async function generateTransferOrderPdf(transferOrderId: number): Promise<string> {
  const data = await apiFetch<{ pdfBase64: string }>(
    `/api/manufacturing/transfers/${String(transferOrderId)}/transfer-order-pdf`,
    { method: "POST", body: {} },
  );
  return data.pdfBase64;
}

export function downloadTransferOrderPdf(base64: string, transferNumber: string | null, transferOrderId: number): void {
  const label = transferNumber?.trim() || `transfer-${String(transferOrderId)}`;
  const link = document.createElement("a");
  link.href = `data:application/pdf;base64,${base64}`;
  link.download = `${label}-transfer-order.pdf`;
  link.click();
}
